import { render, staticRenderFns } from "./ad-downloads-items.vue?vue&type=template&id=9b5bcadc"
import script from "./ad-downloads-items.vue?vue&type=script&lang=ts"
export * from "./ad-downloads-items.vue?vue&type=script&lang=ts"
import style0 from "./ad-downloads-items.vue?vue&type=style&index=0&id=9b5bcadc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports